import script from "./esAppointmentsContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./esAppointmentsContent.vue?vue&type=script&setup=true&lang=ts"

import "./esAppointmentsContent.vue?vue&type=style&index=0&id=44540d72&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44540d72"]])

export default __exports__